export class FileUtilities {
  
  public static ConvertBase64ToBlob(b64Data, contentType = "", sliceSize = 512): Blob {
    b64Data = b64Data.replace(/\s/g, ""); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  public static DownLoadFileV2(FileBase64: any, name: string, type: string) {
    var blob = this.ConvertBase64ToBlob(FileBase64, type);
    let file = new File([blob], name, {
      type: type,
    });

    let url = window.URL.createObjectURL(file);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      alert("Por favor desactiva el bloqueo de ventanas emergentes");
    }
  }
}
